// eslint-disable-next-line
// @ts-nocheck
import { getOriginPath, i18n } from '@/lang/i18n';
import { toast } from '@/utils/toast';
import { getCookie } from '@/utils/cookie';
import { pinia } from '@/store';
import { useUserStore } from '@/store/User';

const userStore = useUserStore(pinia);

// 子账户限制路由
const forbiddenSubAccountRoute = ['/user/invite', '/user/kyc', '/user/sub-account', '/withdrawal',  /^\/withdrawal\/[a-zA-Z0-9]{1,20}$/, /^\/sub-orders\/(spot|futures)\/[a-zA-Z0-9]{1,20}$/, '/sub-assets-transfer'];
/**
 * 是否禁止子账户进入
 *
 * @param path 路由path
 * @returns
 */
const isForbidenSubAccount = (path: string) => {
  return forbiddenSubAccountRoute.some((item: any) => {
    const originPath = getOriginPath(path);
    if (item instanceof RegExp) {
      return item.test(originPath);
    } else {
      return item === originPath;
    }
  });
};
const checkLastSlash = str => {
  const regex = /\/$/;
  return regex.test(str);
};

export default {
  beforeEach: [({ fullPath, path, meta }: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext):void => {
    const { auth } = meta;
    const token = getCookie('c_token');

    // 禁止登录状态访问的页面
    const forbiddenRoute = ['/login', '/reset-password', '/register'];

    // 禁止登录态访问登录页
    const filterLoginPage = () => {
      if (forbiddenRoute.some((forbiddenPath: string) => path.includes(forbiddenPath))) {
        // h5页面返回login时会报404 处理方式 path: '/' => path: ''
        next({ path: checkLastSlash(fullPath) ? '' : '/' });
      }

      // if (forbiddenRoute.includes(getOriginPath(path))) {
      //   next({ path: '/' });
      // }
    };

    // 子账户跳转限制
    const filterSubAccount = () => {
      if (userStore.isSubAccount && isForbidenSubAccount(path)) {
        toast.error(i18n.global.t('此功能不支持子账户类型操作'));
        next({ path: '/' });
      }
    };

    // 跳转登录
    const toLogin = () => {
      next({
        path: '/login',
        query: {
          backurl: fullPath
        }
      });
    };

    // 获取用户登录态
    const login = async() => {
      const isLoginSuccess = await userStore.getUserinfo();
      if (isLoginSuccess) {
        filterLoginPage();
        filterSubAccount();
        next();
      } else {
        auth === 'login' ? toLogin() : next();
      }
    };

    // 忽略登录态和用户信息
    if (auth === 'ignore') {
      return next();
    }

    if (token) {
      if (userStore.isLogin) {
        filterLoginPage();
        filterSubAccount();
        next();
      } else {
        login();
      }
    } else if (auth === 'login') {
      toLogin();
    } else {
      next();
    }
  }]
};
